import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UiServices } from 'src/app/services/ui-services';
import { FormMyGiftCardsComponent } from '../form-my-gift-cards/form-my-gift-cards.component';
import { GiftCardService } from 'src/app/services/gift-card.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-gift-card',
  templateUrl: './form-gift-card.component.html',
  styleUrls: ['./form-gift-card.component.scss'],
})
export class FormGiftCardComponent implements OnInit {
  @Input() totalAmountForGiftCard = 0;
  @Input() item: any;
  @Input() dynamicForm: FormGroup<any>;
  @Output() emitCheckboxes$ = new EventEmitter();

  constructor(private uiSv: UiServices, private giftCardSv: GiftCardService) {}

  ngOnInit() {
    this.item.select = this.item.select.sort(
      (a, b) => b.percentage - a.percentage
    );

    const checkedCouponOrGiftCard = this.item.select[0];
    if (checkedCouponOrGiftCard) {
      if (
        (checkedCouponOrGiftCard.minimumAmount &&
          this.totalAmountForGiftCard <=
            checkedCouponOrGiftCard.minimumAmount) ||
        !checkedCouponOrGiftCard.minimumAmount
      ) {
        this.item.select[0].checked = true;
        this.setNewAmount();
      }
    }
  }

  async showAllMyGiftCards(giftCardsAndCoupons: any[], label) {
    giftCardsAndCoupons.forEach((x) => {
      if (!('checked' in x)) {
        x.checked = false;
      }
    });
    await this.uiSv.showModal(
      FormMyGiftCardsComponent,
      {
        giftCardsAndCoupons,
        label,
        totalAmountForGiftCard: this.totalAmountForGiftCard,
      },
      'select-my-gift-card'
    );

    this.setNewAmount();
  }

  setCheckboxes(ev, formName, checkbox, item?, card?) {
    setTimeout(() => {
      card.checked = false;
      this.emitClickedIdCard(card.id);
      this.setNewAmount();
    });
    this.emitCheckboxes$.emit({ ev, formName, checkbox, item });
  }

  setNewAmount() {
    const giftCardToReduce = this.item.select.filter((x) => x.checked);
    this.dynamicForm
      .get('userGiftCard')
      .setValue(giftCardToReduce.map((x) => x.id));

    this.giftCardSv.setNewAmount(
      giftCardToReduce.reduce((init, next) => (init += next.price), 0)
    );

    giftCardToReduce.forEach((x) => {
      this.giftCardSv.emitCheckboxesId(x.id);
    });
  }

  emitClickedIdCard(id) {
    this.giftCardSv.emitCheckboxesId(id);
  }
}
